import type { ReactElement, ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

/** Hover delay for sidebar/grid labels; paired with skipDelayDuration=0 to avoid scroll flicker. */
export const FILE_CENTER_TOOLTIP_DELAY_MS = 700;

const FILE_CENTER_TOOLTIP_CONTENT_CLASS =
  "z-50 max-w-lg overflow-visible whitespace-normal break-words text-left [overflow-wrap:anywhere]";

export function FileCenterTooltipProvider({ children }: { children: ReactNode }) {
  return (
    <TooltipProvider delayDuration={FILE_CENTER_TOOLTIP_DELAY_MS} skipDelayDuration={0}>
      {children}
    </TooltipProvider>
  );
}

type FileCenterItemTooltipProps = {
  label: string;
  children: ReactElement;
  /** Prefer right-side tooltips in the narrow sidebar tree. */
  side?: "top" | "right";
};

export function FileCenterItemTooltip({ label, children, side = "top" }: FileCenterItemTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} className={FILE_CENTER_TOOLTIP_CONTENT_CLASS}>
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
